import { Controller } from "@hotwired/stimulus";

// The org-switcher and page-nav dropdowns themselves are now rendered by
// Shared::SearchableDropdownComponent (server-rendered, client-built menu).
export default class extends Controller {
  static targets = ["actionsSlot"];

  declare readonly actionsSlotTarget: HTMLElement;
  declare readonly hasActionsSlotTarget: boolean;

  private movedActionBar: HTMLElement | null = null;

  connect() {
    this.portalActionBar();
  }

  disconnect() {
    this.movedActionBar = null;
  }

  private portalActionBar() {
    if (!this.hasActionsSlotTarget) return;
    const bar = document.querySelector<HTMLElement>(".table-action-bar");
    if (!bar) return;
    this.actionsSlotTarget.appendChild(bar);
    this.movedActionBar = bar;
  }
}
